import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/src/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md',
    },
    lang: {
        locales: {de},
        current: 'de'
    },
    theme: {
        options: {
            customProperties: true // export css vars
        }
    }
});
